import { Map } from 'immutable'
import _get from 'lodash/get'
import {
  SET_USER_PROCESSING,
  GET_USERS_BY_QUERY,
  SET_USERS_BY_QUERY,
  SET_USERS_BY_QUERY_ERROR,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case GET_USERS_BY_QUERY:
      return state.setIn([payload.storeKey, 'processing'], true)
    case SET_USER_PROCESSING:
      return state.set('processing', payload.processing)
    case SET_USERS_BY_QUERY:
      return state
        .setIn([payload.storeKey, 'data'], _get(payload, 'data', Map()))
        .setIn([payload.storeKey, 'processing'], false)
        .setIn([payload.storeKey, 'error'], null)
        .setIn([payload.storeKey, 'message'], null)
    case SET_USERS_BY_QUERY_ERROR:
      return state
        .setIn([payload.storeKey, 'data'], [])
        .setIn([payload.storeKey, 'processing'], false)
        .setIn([payload.storeKey, 'error'], payload.error)
        .setIn([payload.storeKey, 'message'], null)
    default:
      return state
  }
}
